import "../../styles/ambient_layer.css";

/**
 * Fixed decorative layer: soft colour orbs that drift on a loop (CSS only).
 */
export default function AmbientLayer() {
  return (
    <div className="ambient-layer" aria-hidden>
      <div className="ambient-layer__orb ambient-layer__orb--a" />
      <div className="ambient-layer__orb ambient-layer__orb--b" />
      <div className="ambient-layer__orb ambient-layer__orb--c" />
    </div>
  );
}
